import { useState } from "react";

export function PatientStatsBox({
    stats
}: {
    stats: { title: string; items: { label: string; value: string | number }[] }[];
}) {
    return (
        <div className="w-full space-y-5">
            <div className="font-bold text-lg">Statistiche</div>
            {stats.map((section) => (
                <ExpandableStatSection
                    key={section.title}
                    title={section.title}
                    items={section.items}
                />
            ))}
        </div>
    );
}

function ExpandableStatSection({
    title,
    items,
}: {
    title: string;
    items: { label: string; value: string | number }[];
}) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border rounded-xl p-4 border border-solid border-holifya-grey-shadow shadow-platform-new">
            <div
                onClick={() => setIsOpen(!isOpen)}
                className="flex justify-between items-center cursor-pointer"
            >
                <div className="font-semibold text-sm">{title}</div>
                <div className="text-xs text-blue-600">{isOpen ? "Mostra meno" : "Mostra di più"}</div>
            </div>

            {isOpen && (
                <div className="mt-2 space-y-1 text-sm text-gray-700">
                    {items.map(({ label, value }) => (
                        <div key={label}>
                            <span className="font-bold">{label}:</span> <span>{value}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
